{
    "DarkMode_Switch_Title": "Dunkler Modus",
    "NAME": "DarkMode",
    "DarkMode_SwitchLight_Title": "Lichtmodus"
}